export default {"src":"/_next/static/image/public/images/ic_flash_upcoming.b1a43eacd6d9f02c04c5da0aad7662e6.svg","height":16,"width":59};